import { useEffect, useMemo } from 'react';

import AcInput from 'components/AcInput/AcInput';

import { INTEGRATION_SETTINGS_FIELDS } from './integrationSettingsConstants';
import { integrationFields } from './integrationSettingsSchema';

import './style.scss';

interface IAwardingFieldsProps {
  values: any;
  errors: any;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => Promise<void> | Promise<any>;
}

const AwardingFields = ({
  values,
  setFieldValue,
  errors
}: IAwardingFieldsProps) => {
  const ratioDisplayValue = useMemo(() => {
    if (!values) return [null, null];
    const v1Ratio = ((1 - values.awardingV2Ratio || 0) * 100).toFixed(0);
    const v2Ratio = (values.awardingV2Ratio * 100).toFixed(0);
    return [v1Ratio, v2Ratio];
  }, [values]);

  useEffect(() => {
    if (!values.ordersReportingApiUrl) {
      setFieldValue('awardingV2Ratio', calculateAwardingV2Ratio(0, false));
    }
    if (!values.awardingV2ApiUrl) {
      setFieldValue('awardingV2Ratio', calculateAwardingV2Ratio(0, true));
    }
  }, [values.ordersReportingApiUrl, values.awardingV2ApiUrl, setFieldValue]);

  const calculateAwardingV2Ratio = (value: number, isV2: boolean) => {
    const ratio = isV2 ? value / 100 : (100 - value) / 100;
    if (ratio < 0) return 0;
    if (ratio > 1) return 1;
    return ratio;
  };

  return (
    <div className="awarding-fields-container w-full p-8">
      <h1 className="mb-5">
        {
          integrationFields[INTEGRATION_SETTINGS_FIELDS.AWARDING_V2_API_URL]
            .label
        }
      </h1>
      <div className="w-full">
        <div className="flex items-center justify-between gap-4 mb-4 awarding-field-container">
          <div className="awarding-field-version">V1</div>
          <AcInput
            onChange={(e) =>
              setFieldValue(
                INTEGRATION_SETTINGS_FIELDS.ORDERS_REPORTING_API_URL,
                e.target.value
              )
            }
            value={values?.ordersReportingApiUrl || ''}
            error={errors[INTEGRATION_SETTINGS_FIELDS.ORDERS_REPORTING_API_URL]}
            helperText={
              errors[INTEGRATION_SETTINGS_FIELDS.ORDERS_REPORTING_API_URL]
            }
          />
          <div className="relative w-[80px] awarding-ratio-wrapper">
            <AcInput
              type="number"
              value={ratioDisplayValue[0]}
              onChange={(e) =>
                setFieldValue(
                  'awardingV2Ratio',
                  calculateAwardingV2Ratio(Number(e.target.value), false)
                )
              }
              disabled={
                !values.ordersReportingApiUrl || !values.awardingV2ApiUrl
              }
              customClass="awarding-ratio-input"
            />
            <span className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-600 z-10">
              %
            </span>
          </div>
        </div>
        <div className="flex items-center justify-between gap-4 mb-4 awarding-field-container">
          <div className="awarding-field-version">V2</div>
          <AcInput
            onChange={(e) =>
              setFieldValue(
                INTEGRATION_SETTINGS_FIELDS.AWARDING_V2_API_URL,
                e.target.value
              )
            }
            value={values?.awardingV2ApiUrl || ''}
            error={errors[INTEGRATION_SETTINGS_FIELDS.AWARDING_V2_API_URL]}
            helperText={errors[INTEGRATION_SETTINGS_FIELDS.AWARDING_V2_API_URL]}
          />
          <div className="relative w-[80px] awarding-ratio-wrapper">
            <AcInput
              type="number"
              value={ratioDisplayValue[1]}
              onChange={(e) =>
                setFieldValue(
                  'awardingV2Ratio',
                  calculateAwardingV2Ratio(Number(e.target.value), true)
                )
              }
              disabled={
                !values.awardingV2ApiUrl || !values.ordersReportingApiUrl
              }
              customClass="awarding-ratio-input"
            />
            <span className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-600 z-10">
              %
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AwardingFields;
